/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "îr",
        "-2": "îr l’altri",
        "0": "vuê",
        "1": "doman",
        "2": "passantdoman",
        "future": {
          "one": "ca di {0} zornade",
          "other": "ca di {0} zornadis"
        },
        "past": {
          "one": "{0} zornade indaûr",
          "other": "{0} zornadis indaûr"
        }
      },
      "day-narrow": {
        "-1": "îr",
        "-2": "îr l’altri",
        "0": "vuê",
        "1": "doman",
        "2": "passantdoman",
        "future": {
          "one": "ca di {0} zornade",
          "other": "ca di {0} zornadis"
        },
        "past": {
          "one": "{0} zornade indaûr",
          "other": "{0} zornadis indaûr"
        }
      },
      "day-short": {
        "-1": "îr",
        "-2": "îr l’altri",
        "0": "vuê",
        "1": "doman",
        "2": "passantdoman",
        "future": {
          "one": "ca di {0} zornade",
          "other": "ca di {0} zornadis"
        },
        "past": {
          "one": "{0} zornade indaûr",
          "other": "{0} zornadis indaûr"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "ca di {0} ore",
          "other": "ca di {0} oris"
        },
        "past": {
          "one": "{0} ore indaûr",
          "other": "{0} oris indaûr"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "ca di {0} ore",
          "other": "ca di {0} oris"
        },
        "past": {
          "one": "{0} ore indaûr",
          "other": "{0} oris indaûr"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "ca di {0} ore",
          "other": "ca di {0} oris"
        },
        "past": {
          "one": "{0} ore indaûr",
          "other": "{0} oris indaûr"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "ca di {0} minût",
          "other": "ca di {0} minûts"
        },
        "past": {
          "one": "{0} minût indaûr",
          "other": "{0} minûts indaûr"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "ca di {0} minût",
          "other": "ca di {0} minûts"
        },
        "past": {
          "one": "{0} minût indaûr",
          "other": "{0} minûts indaûr"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "ca di {0} minût",
          "other": "ca di {0} minûts"
        },
        "past": {
          "one": "{0} minût indaûr",
          "other": "{0} minûts indaûr"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "ca di {0} mês",
          "other": "ca di {0} mês"
        },
        "past": {
          "one": "{0} mês indaûr",
          "other": "{0} mês indaûr"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "ca di {0} mês",
          "other": "ca di {0} mês"
        },
        "past": {
          "one": "{0} mês indaûr",
          "other": "{0} mês indaûr"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "ca di {0} mês",
          "other": "ca di {0} mês"
        },
        "past": {
          "one": "{0} mês indaûr",
          "other": "{0} mês indaûr"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "one": "ca di {0} secont",
          "other": "ca di {0} seconts"
        },
        "past": {
          "one": "{0} secont indaûr",
          "other": "{0} seconts indaûr"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "one": "ca di {0} secont",
          "other": "ca di {0} seconts"
        },
        "past": {
          "one": "{0} secont indaûr",
          "other": "{0} seconts indaûr"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "one": "ca di {0} secont",
          "other": "ca di {0} seconts"
        },
        "past": {
          "one": "{0} secont indaûr",
          "other": "{0} seconts indaûr"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "ca di {0} setemane",
          "other": "ca di {0} setemanis"
        },
        "past": {
          "one": "{0} setemane indaûr",
          "other": "{0} setemanis indaûr"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "ca di {0} setemane",
          "other": "ca di {0} setemanis"
        },
        "past": {
          "one": "{0} setemane indaûr",
          "other": "{0} setemanis indaûr"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "ca di {0} setemane",
          "other": "ca di {0} setemanis"
        },
        "past": {
          "one": "{0} setemane indaûr",
          "other": "{0} setemanis indaûr"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "ca di {0} an",
          "other": "ca di {0} agns"
        },
        "past": {
          "one": "{0} an indaûr",
          "other": "{0} agns indaûr"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "ca di {0} an",
          "other": "ca di {0} agns"
        },
        "past": {
          "one": "{0} an indaûr",
          "other": "{0} agns indaûr"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "ca di {0} an",
          "other": "ca di {0} agns"
        },
        "past": {
          "one": "{0} an indaûr",
          "other": "{0} agns indaûr"
        }
      }
    },
    "locale": "fur"
  });
}